import { render, staticRenderFns } from "./addStock.vue?vue&type=template&id=67b284f7&scoped=true&"
import script from "./addStock.vue?vue&type=script&lang=js&"
export * from "./addStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b284f7",
  null
  
)

export default component.exports